import { createReducer, on } from '@ngrx/store';

import * as fromRootImpeActions from '@apps/root/store/impersonate/impe.actions';
import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';
import * as fromAuthProfileActions from '@apps/auth/store/profile/profile.actions';
import { EntityFilters } from '@apps/prtg/models';
import { StatusesMetadata } from '@common/models';
import { BackPrtgInitialState, IBackPrtgState } from '@apps/back/store/prtg/prtg.state';

import * as fromBackPrtgActions from './prtg.actions';
import { NoContentResult } from '@common/domain/models/no-content-result';

export const BackPrtgReducer = createReducer(
    BackPrtgInitialState,
    on(
        fromRootImpeActions.RootImpersonateSet,
        fromRootImpeActions.RootImpersonateUnset,
        fromAuthProfileActions.AuthProfileApplicationRolesSet,
        fromAuthProfileActions.AuthProfileApplicationRolesReset,
        fromAuthLoginActions.AuthLogout,
        () =>
            BackPrtgInitialState
    ),
    on (
        fromBackPrtgActions.BackPrtgFiltersSucceded,
        (state: IBackPrtgState, { filters }: {filters: string[]}) => ({
            ...state,
            filters: [...filters]
        })
    ),
    on (
        fromBackPrtgActions.BackPrtgEntityFiltersRetrieveRequested,
        (state: IBackPrtgState) => ({
            ...state,
            ...StatusesMetadata.requested()
        })
    ),
    on(
        fromBackPrtgActions.BackPrtgEntityFiltersRetrieveSucceeded,
        (state: IBackPrtgState, { result }: {result: NoContentResult<EntityFilters>}) =>
            ({
                ...state,
                entityFilters: result.value,
                noContent: result.noContent,
                ...StatusesMetadata.succeeded(true, false)
            })
    ),
    on(
        fromBackPrtgActions.BackPrtgEntityFiltersRetrieveFailed,
        (state: IBackPrtgState) => ({
            ...state,
            entityFilters: null,
            noContent: null,
            ...StatusesMetadata.failed()
        })
    ),
    on(
        fromBackPrtgActions.BackPrtgEntityFiltersUpdateRequested,
        (state: IBackPrtgState) => ({
            ...state,
            ...StatusesMetadata.requested()
        })
    ),
    on(
        fromBackPrtgActions.BackPrtgEntityFiltersCleaningRequested,
        fromBackPrtgActions.BackPrtgEntityFiltersUpdateFailed,
        fromBackPrtgActions.BackPrtgEntityFiltersUpdateSucceeded,
        (state: IBackPrtgState) => ({
            ...state,
            entityFilters: null,
            noContent: null,
            ...StatusesMetadata.init()
        })
    )
);
